<div class="unit-tests-container">
    <div class="unit-tests-controls">
        <button mat-raised-button color="primary" (click)="startAllUnitTests()" [disabled]="disableTrigger">
            {{ 'OVERVIEW.UNIT_TESTS.BUTTON.START_ALL' | translate }}
        </button>
    </div>
    <div class="unit-tests">
        <div class="unit-test" *ngFor="let unitTest of unitTests">
            <div class="unit-test-interface">
                <div class="unit-test-details">
                    <div class="details-loading" *ngIf="unitTest.loading">
                        <mat-spinner [diameter]="22"></mat-spinner>
                    </div>
                    <div
                        class="details-status"
                        *ngIf="unitTest.unitTestResponse && !unitTest.loading"
                        [ngClass]="{
                            error: !unitTest.unitTestResponse?.valid,
                            success: unitTest.unitTestResponse?.valid
                        }"
                    >
                        <mat-icon *ngIf="unitTest.unitTestResponse?.valid">close</mat-icon>
                        <mat-icon *ngIf="!unitTest.unitTestResponse?.valid">check</mat-icon>
                    </div>
                    <div class="details-title">
                        {{ unitTest.customerPurchaseNumber }}
                        <span
                            *ngIf="unitTest.loading"
                            [innerHTML]="'OVERVIEW.UNIT_TESTS.TEST.TITLE.LOADING' | translate"
                        ></span>
                    </div>
                </div>
                <div class="unit-test-action">
                    <button
                        mat-raised-button
                        color="primary"
                        [disabled]="disableTrigger"
                        [matTooltip]="'OVERVIEW.UNIT_TESTS.TEST.ACTIONS.START' | translate"
                        (click)="startSingleUnitTest(unitTest.id)"
                    >
                        <mat-icon>start</mat-icon>
                    </button>
                    <button
                        mat-raised-button
                        color="secondary"
                        [matTooltip]="'OVERVIEW.UNIT_TESTS.TEST.ACTIONS.USE' | translate"
                        (click)="onUseClick(unitTest)"
                        *ngIf="isAdmin"
                    >
                        <mat-icon>edit_document</mat-icon>
                    </button>
                    <button
                        mat-raised-button
                        color="secondary"
                        [matTooltip]="'OVERVIEW.UNIT_TESTS.TEST.ACTIONS.EDIT' | translate"
                        (click)="onEditClick(unitTest)"
                        *ngIf="isAdmin"
                    >
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button
                        mat-raised-button
                        color="secondary"
                        [matTooltip]="'OVERVIEW.ACTIONS.DELETE' | translate"
                        (click)="onDeleteClick(unitTest.id, unitTest.customerPurchaseNumber)"
                        *ngIf="isAdmin"
                    >
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </div>
            <div
                class="unit-test-response"
                *ngIf="unitTest.unitTestResponse && !unitTest.unitTestResponse?.valid && !unitTest.loading"
            >
                <div class="response-delta">
                    <div
                        class="delta-price-calculation delta-container"
                        *ngIf="unitTest.unitTestResponse?.priceCalculationError"
                    >
                        <div class="delta-headline">
                            {{ 'OVERVIEW.UNIT_TESTS.TEST.RESPONSE.HEADLINE.PRICE_CALCULATION' | translate }}
                        </div>
                        <div class="delta-item">
                            {{ unitTest.unitTestResponse?.priceCalculationError }}
                        </div>
                    </div>
                    @for (delta of unitTest.unitTestResponse?.linesDelta; track delta.line) { @if
                    (!delta.configuration.valid || !delta.configuration.complete || delta.added.length ||
                    delta.removed.length || delta.modified.length || delta.schemes.primary.added.length ||
                    delta.schemes.primary.removed.length || delta.schemes.secondary.added.length ||
                    delta.schemes.secondary.removed.length) {
                    <div class="delta-line">
                        {{ 'OVERVIEW.UNIT_TESTS.TEST.RESPONSE.TITLE.' + delta.line.toUpperCase() | translate }}
                    </div>
                    }
                    <div
                        class="delta-configuration delta-container"
                        *ngIf="!delta.configuration.valid || !delta.configuration.complete"
                    >
                        <div class="delta-headline">
                            {{ 'OVERVIEW.UNIT_TESTS.TEST.RESPONSE.HEADLINE.CONFIGURATION' | translate }}
                        </div>
                        <div class="delta-item">
                            @if (!delta.configuration.valid) { {{ delta.configuration.invalidMessage }} } @else {
                            {{ 'OVERVIEW.UNIT_TESTS.TEST.RESPONSE.ERROR.INCOMPLETE' | translate }} }
                        </div>
                    </div>
                    <div
                        class="delta-products delta-container"
                        *ngIf="delta.added.length || delta.removed.length || delta.modified.length"
                    >
                        <div class="delta-headline">
                            {{ 'OVERVIEW.UNIT_TESTS.TEST.RESPONSE.HEADLINE.PRODUCTS' | translate }}
                        </div>
                        <div class="delta-item" *ngIf="delta.added.length">
                            <div class="delta-item-title">
                                {{ 'OVERVIEW.UNIT_TESTS.TEST.RESPONSE.ADDED' | translate }}
                            </div>
                            <ul class="delta-item-content" *ngFor="let added of delta.added">
                                <li>
                                    {{ 'OVERVIEW.UNIT_TESTS.TEST.RESPONSE.MATERIAL' | translate }}
                                    {{ added.material }}
                                    {{ added.productDescription }}
                                </li>
                                <li>
                                    {{ 'OVERVIEW.UNIT_TESTS.TEST.RESPONSE.QUANTITY' | translate }}
                                    {{ added.quantity }}
                                </li>
                            </ul>
                        </div>
                        <div class="delta-item" *ngIf="delta.modified.length">
                            <div class="delta-item-title">
                                {{ 'OVERVIEW.UNIT_TESTS.TEST.RESPONSE.MODIFIED' | translate }}
                            </div>
                            <ul class="delta-item-content" *ngFor="let modified of delta.modified">
                                <li>
                                    {{ 'OVERVIEW.UNIT_TESTS.TEST.RESPONSE.MATERIAL' | translate }}
                                    {{ modified.material }}
                                    {{ modified.productDescription }}
                                </li>
                                <li>
                                    {{ 'OVERVIEW.UNIT_TESTS.TEST.RESPONSE.IS_QUANTITY' | translate }}
                                    {{ modified.oldQuantity }}
                                </li>
                                <li>
                                    {{ 'OVERVIEW.UNIT_TESTS.TEST.RESPONSE.SHOULD_QUANTITY' | translate }}
                                    {{ modified.quantity }}
                                </li>
                            </ul>
                        </div>
                        <div class="delta-item" *ngIf="delta.removed.length">
                            <div class="delta-item-title">
                                {{ 'OVERVIEW.UNIT_TESTS.TEST.RESPONSE.REMOVED' | translate }}
                            </div>
                            <ul class="delta-item-content" *ngFor="let removed of delta.removed">
                                <li>
                                    {{ 'OVERVIEW.UNIT_TESTS.TEST.RESPONSE.MATERIAL' | translate }}
                                    {{ removed.material }} {{ removed.productDescription }}
                                </li>
                                <li>
                                    {{ 'OVERVIEW.UNIT_TESTS.TEST.RESPONSE.QUANTITY' | translate }}
                                    {{ removed.quantity }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div
                        class="delta-generic-products delta-container"
                        *ngIf="delta.genericProducts.added.length || delta.genericProducts.modified.length"
                    >
                        <div class="delta-headline">
                            {{ 'OVERVIEW.UNIT_TESTS.TEST.RESPONSE.HEADLINE.GENERIC_PRODUCTS' | translate }}
                        </div>
                        <div class="delta-item" *ngIf="delta.genericProducts.added.length">
                            <div class="delta-item-title">
                                {{ 'OVERVIEW.UNIT_TESTS.TEST.RESPONSE.ADDED' | translate }}
                            </div>
                            <ul class="delta-item-content" *ngFor="let added of delta.genericProducts.added">
                                <li>
                                    {{ 'OVERVIEW.UNIT_TESTS.TEST.RESPONSE.MATERIAL' | translate }}
                                    {{ added.material }}
                                    {{ added.productDescription }}
                                </li>
                                <li>
                                    {{ 'OVERVIEW.UNIT_TESTS.TEST.RESPONSE.PRICE' | translate }}
                                    {{
                                        added.price | currency: 'EUR':'symbol':'1.2-2':appService.getLanguageAsLocale()
                                    }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div
                        class="delta-schemes delta-container"
                        *ngIf="
                            delta.schemes.primary.added.length ||
                            delta.schemes.primary.removed.length ||
                            delta.schemes.secondary.added.length ||
                            delta.schemes.secondary.removed.length
                        "
                    >
                        <ng-container
                            *ngIf="delta.schemes.primary.added.length || delta.schemes.primary.removed.length"
                        >
                            <div class="delta-headline">
                                {{ 'OVERVIEW.UNIT_TESTS.TEST.RESPONSE.HEADLINE.PRIMARY_SCHEME' | translate }}
                            </div>
                            <div class="delta-item" *ngIf="delta.schemes.primary.added.length">
                                <div class="delta-item-title">
                                    {{ 'OVERVIEW.UNIT_TESTS.TEST.RESPONSE.ADDED' | translate }}
                                </div>
                                <ul class="delta-item-content">
                                    <li *ngFor="let item of delta.schemes.primary.added">{{ item }}</li>
                                </ul>
                            </div>
                            <div class="delta-item" *ngIf="delta.schemes.primary.removed.length">
                                <div class="delta-item-title">
                                    {{ 'OVERVIEW.UNIT_TESTS.TEST.RESPONSE.REMOVED' | translate }}
                                </div>
                                <ul class="delta-item-content">
                                    <li *ngFor="let item of delta.schemes.primary.removed">{{ item }}</li>
                                </ul>
                            </div>
                        </ng-container>
                        <ng-container
                            *ngIf="delta.schemes.secondary.added.length || delta.schemes.secondary.removed.length"
                        >
                            <div class="delta-headline">
                                {{ 'OVERVIEW.UNIT_TESTS.TEST.RESPONSE.HEADLINE.SECONDARY_SCHEME' | translate }}
                            </div>
                            <div class="delta-item" *ngIf="delta.schemes.secondary.added.length">
                                <div class="delta-item-title">
                                    {{ 'OVERVIEW.UNIT_TESTS.TEST.RESPONSE.ADDED' | translate }}
                                </div>
                                <ul class="delta-item-content">
                                    <li *ngFor="let item of delta.schemes.secondary.added">{{ item }}</li>
                                </ul>
                            </div>
                            <div class="delta-item" *ngIf="delta.schemes.secondary.removed.length">
                                <div class="delta-item-title">
                                    {{ 'OVERVIEW.UNIT_TESTS.TEST.RESPONSE.REMOVED' | translate }}
                                </div>
                                <ul class="delta-item-content">
                                    <li *ngFor="let item of delta.schemes.secondary.removed">{{ item }}</li>
                                </ul>
                            </div>
                        </ng-container>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
